import React from "react";
import { RiArrowGoBackFill } from "react-icons/ri";
import { DetailContainer } from "../../../../styled/setting";
import Info from "../../../common/info";
import { formatQuantity, status } from "../../../../function/store";

const DetailProduct = ({ selected, categoriesObj, changeTab, clickImages, initialOptions }) => {
  const detailFields = [
    { key: "name", label: "메뉴명" },
    {
      key: "price",
      label: "가격",
      render: (val) => <div className="cont">{formatNumber(val || 0)}원</div>,
    },
    {
      key: "media",
      label: "메뉴사진",
      render: (item) => (
        <div className="cont">
          {item?.length > 0
            ? item.map((ele, i) => (
                <img key={i} src={imgHandler(ele)} alt="" onClick={() => clickImages(item, i)} />
              ))
            : ""}
        </div>
      ),
    },
    { key: "specifications", label: "규격" },
    { key: "shortDescription", label: "메뉴한줄설명" },
    { key: "brand", label: "브랜드" },
    {
      key: "status",
      label: "상품상태",
      render: (val) => <div className="cont">{status[val]}</div>,
    },
    {
      key: "categoryId",
      label: "카테고리",
      render: (val) => <div className="cont">{categoriesObj[val] || "-"}</div>,
    },
    {
      key: "quantity",
      label: "수량",
      render: (val) => <div className="cont">{formatQuantity(val)}</div>,
    },
    {
      key: "tags",
      label: "태그",
      render: (val) => (
        <div className="cont">
          {val &&
            val.length > 0 &&
            val.map((tag, index) => (
              <span>
                {tag}
                {index !== val.length - 1 && ", "}
              </span>
            ))}
        </div>
      ),
    },
    {
      key: "description",
      label: "메뉴설명",
      render: (item) =>
        item ? <div dangerouslySetInnerHTML={{ __html: item }} className="cont" /> : "",
    },
  ];

  return (
    <DetailContainer>
      <Info
        message="자세히보기"
        actions={[{ Icon: RiArrowGoBackFill, func: () => changeTab(0, null), key: "exit" }]}
      />
      <div className="contents">
        <ul>
          {detailFields.map(({ key, label, render }) => {
            const value = selected?.[key];
            return (
              <li key={key} className={key}>
                <span className="tit">{label}</span>
                {render ? render(value) : <div className="cont">{value || "-"}</div>}
              </li>
            );
          })}
          <li className="options">
            <span className="tit">옵션</span>
            <div className="cont">
              {initialOptions.length > 0 ? (
                initialOptions.map((option) => (
                  <div className="opt">
                    <strong>{option.name}</strong>
                    <ul>
                      {option.options.map((opt) => (
                        <li>
                          <strong>{opt.value}</strong>
                          <span>
                            +{opt?.addPrice ? formatNumber(toNumber(opt.addPrice) || 0) : 0}원
                          </span>
                        </li>
                      ))}
                    </ul>
                  </div>
                ))
              ) : (
                <>-</>
              )}
            </div>
          </li>
        </ul>
      </div>
    </DetailContainer>
  );
};

export default DetailProduct;
